import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await register(email, password, name);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Konto erstellt!");
      navigate("/dashboard");
    } else {
      toast.error(res.error || "Registrierung fehlgeschlagen");
    }
  };

  const onGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 grain">
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="flex items-center justify-center mb-10">
          <Logo size={72} withText />
        </Link>
        <div className="rounded-2xl border border-white/10 bg-zinc-950 p-8 shadow-2xl">
          <h1 className="font-heading text-3xl mb-2">Konto erstellen</h1>
          <p className="text-sm text-zinc-400 mb-8">Stempelkarte starten & beim 6. Termin gratis fahren.</p>

          <Button
            data-testid="register-google-button"
            onClick={onGoogle}
            variant="outline"
            className="w-full rounded-full border-white/15 bg-transparent hover:bg-white/5 mb-6 h-11"
          >
            Mit Google fortfahren
          </Button>

          <div className="flex items-center gap-3 my-6">
            <div className="flex-1 h-px bg-white/10" />
            <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">oder</span>
            <div className="flex-1 h-px bg-white/10" />
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-[0.2em] text-zinc-500">Name</Label>
              <Input
                data-testid="register-name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-2 bg-zinc-900 border-zinc-800 h-11"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-[0.2em] text-zinc-500">E-Mail</Label>
              <Input
                data-testid="register-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-zinc-900 border-zinc-800 h-11"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-[0.2em] text-zinc-500">Passwort</Label>
              <Input
                data-testid="register-password"
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-zinc-900 border-zinc-800 h-11"
              />
            </div>
            <Button
              data-testid="register-submit"
              type="submit"
              disabled={submitting}
              className="w-full rounded-full bg-primary text-primary-foreground hover:brightness-110 h-11"
            >
              {submitting ? "Konto wird erstellt…" : "Konto erstellen"}
            </Button>
          </form>

          <p className="text-center text-sm text-zinc-400 mt-6">
            Schon registriert?{" "}
            <Link to="/login" data-testid="register-go-login" className="text-primary hover:underline">
              Anmelden
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
